import type { SpatialEvent } from '@/types';
import { TypedEmitter } from './eventEmitter';

/** Application-wide bus for engine events. One instance per running environment. */
export type SpatialEventBus = TypedEmitter<SpatialEvent>;

export const createEventBus = (): SpatialEventBus => new TypedEmitter<SpatialEvent>();
